import Vue from 'vue';
import Router from 'vue-router';
import login from '@/mainModules/login.vue';
import home from '@/mainModules/home.vue';
import blank from '@/components/blank.vue';
import notFound from '@/components/notFound.vue';
import onlineUsers from './commons/onlineUsers.js';
Vue.use(Router);
const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(error => error);
};
const router = new Router({
    routes: [
        {
            path: '/allBlank',
            meta: {
                requireAuth: true
            },
            component: blank
        },
        {
            path: '/home',
            name: 'home',
            component: home,
            meta: {
                requireAuth: true
            },
            children: [
                {
                    path: '/notFound',
                    meta: {
                        requireAuth: true
                    },
                    component: notFound
                },
                {
                    path: '/userCenter/userCenter',
                    name: '/userCenter/userCenter',
                    component: () => import('@/mainModules/userCenter/userCenter.vue')
                },
                {
                    path: '/onlineUsers/onlineUsers',
                    name: '/onlineUsers/onlineUsers',
                    component: () => import('@/mainModules/onlineUsers/onlineUsers.vue')
                }
            ]
        }
    ],
    strict: process.env.NODE_ENV !== 'production'
});
if (window.config.useMainIndex) {
    router.options.routes.push({
        path: '/',
        meta: {
            requireAuth: false
        },
        component: login
    });
    router.addRoutes(router.options.routes);
}
let init = false;
router.beforeEach((to, from, next) => {
    if (to.path === '/') {
        sessionStorage.clear();
        onlineUsers.endMQSend();
        router.options.routes[1].children.splice(2, router.options.routes[1].children.length);
    }
    if (to.meta.requireAuth === false || sessionStorage.getItem('token') || to.path === '/') {
        // if ((to.matched.length === 0 && to.path != '/' && router.options.routes[1].children.length <= 2) || (to.matched.length === 0 && to.path === '/notFound')) {
        //     let menuData = sessionStorage.getItem('menuData');
        //     let indexId = sessionStorage.getItem('leftMenuIndexId');
        //     let retInfo = util.addRouter(JSON.parse(menuData), router.options.routes[1].children, indexId);
        //     router.options.routes[1].children = retInfo[0];
        //     router.addRoutes(router.options.routes);
        //     if (retInfo[1]) {
        //         next('/' + indexId);
        //     } else {
        //         next();
        //     }
        // } else
        if (sessionStorage.getItem('token') && !init) {
            next('/');
        } else if (sessionStorage.getItem('token') && to.matched.length === 0 && to.path != '/' && to.path != '/notFound') {
            next('/notFound');
        } else {
            next();
        }
        init = true;
    } else {
        next('/');
    }
});

router.afterEach(to => {
    /* 路由发生变化修改页面 title */
    if (to.meta.title) {
        document.title = to.meta.title;
    }
});
export default router;
